import { lazy } from 'react';

export const SecretKeyLazy = lazy(() => import('./SecretKey'));
